module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    attrs: {
      "id": "ban"
    }
  }, [_c('ul', {
    attrs: {
      "id": "banner"
    }
  }, [_c('li', [_c('div', {
    staticClass: "text"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/reviews_user5.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('reviews_user5')))]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('reviews_con5')))]), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.$t('reviews_data5')))])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/reviews_user1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('reviews_user1')))]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('reviews_con1')))]), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.$t('reviews_data1')))])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/reviews_user2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('reviews_user2')))]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('reviews_con2')))]), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.$t('reviews_data2')))])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/reviews_user3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('reviews_user3')))]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('reviews_con3')))]), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.$t('reviews_data3')))])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/reviews_user4.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('reviews_user4')))]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('reviews_con4')))]), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.$t('reviews_data4')))])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/reviews_user5.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('reviews_user5')))]), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('reviews_con5')))]), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.$t('reviews_data5')))])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/reviews_user1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('reviews_user1')))]), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('reviews_con1')))]), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.$t('reviews_data1')))])])])])])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reviews-star"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reviews-star"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reviews-star"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reviews-star"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reviews-star"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reviews-star"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reviews-star"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-review-star.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "arrow",
    attrs: {
      "href": "javascript:;",
      "id": "prev"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-arrow.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "arrow",
    attrs: {
      "href": "javascript:;",
      "id": "next"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-arrow.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ebde7f38!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/promotion/Netflix/ReviewText.vue
// module id = 1401
// module chunks = 1